import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router";
import { PageImageHeader } from "./../../components/pageImageHeader";
import * as WebRoutes from "@travellocal/utils/webRoutes";

export const Accessibility = () => (
  <div className="accessibility">
    <Helmet
      title="Accessibility"
      link={[
        {
          rel: "canonical",
          href: `${globalConfig.wwwBaseUrl}${WebRoutes.accessibility()}`,
        },
      ]}
    />
    <PageImageHeader imageSrc="/images/locations/21.jpg" imageMeta="Overlooking Yangshuo, China at dusk" title="Accessibility statement" spaceForTabs={false} />

    <div className="width-wrapper">
      <div className="main-content">
        <div className="intro">
          <p>We work hard to improve the accessibility of our website, taking guidance from many of the available standards and guidelines. At TravelLocal we appreciate the importance of providing a website that is accessible to the widest possible audience, regardless of ability or the technology that you use to access the internet.</p>
        </div>

        <h3>Font Sizes</h3>

        <p>You can change the font size of text on this website by changing settings in your web browser.</p>

        <ul>
          <li><p>Internet Explorer: Select the View tab, then Text Size, then choose the size you wish to use.</p></li>
          <li><p>Firefox: Select the View tab, then Text Size, then Increase or Decrease.</p></li>
          <li><p>Chrome: Click on the spanner icon in the top right hand corner.Increase or decrease the zoom to change the font size.</p></li>
          <li><p>Safari: Click on the menu icon in the top right hand corner. Go to Zoom and use Zoom in and Zoom out to change the font size.</p></li>
        </ul>

        <h3>Links</h3>

        <p>Rather than using 'read more' or 'click here', wherever possible we have strived to make text which links one web page to another web page relevant to the page behind the link.</p>

        <h3>New tabs</h3>

        <p>Clicking on certain links on our site will cause a new tab to open in your browser, to enable easy navigation back to TravelLocal. Examples of this include: </p>

        <ul>
          <li><p>Adobe pdfs (see <a href="http://www.adobe.com" target="_blank">www.adobe.com</a> for more information) </p></li>
          <li><p>Links to third party websites</p></li>
          <li><p>Links to help topics</p></li>
          <li><p>Any link where we say ‘opens in new window’</p></li>
        </ul>

        <h3>Potential Accessibility Barriers</h3>

        <p>Whilst we strive to adhere to the accepted guidelines and standards for accessibility, it is not always possible to do so in all areas of the website.Current instances that we are aware of include: </p>

        <ul>
          <li><p>Certain pages and action buttons require javascript to be able to take full advantage of the available functionality</p></li>
          <li><p>The pop-up calendar requires javascript to select dates (however, dates can be manually inputted using the keyboard) </p></li>
        </ul>

        <p>We are continually making active improvements to our site to remove these potential barriers, so please do keep checking our site over the coming months.</p>

        <h3>Contact Us</h3>

        <p>If you need help to guide you through using the site or have a general query, please <Link to={WebRoutes.contactUs()}>contact us</Link>.</p>
      </div>
    </div>
  </div>
);
